import React from "react";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import default CSS
import "./confirm-alert.css";

const ConfirmDialog  = ({ isOpen, title, message, onConfirm, onCancel }) => {
  if (!isOpen) return null; // Render nothing if the dialog is not open

  return (
    <div className="custom-alert-overlay">
      <div className="custom-alert-modal">
        <h1>{title}</h1>
        <p>{message}</p>
        <div className="mt-4">
          <button
            onClick={onConfirm}
            className="bg-red-500 text-white px-4 py-2 rounded-md"
          >
            Yes
          </button>
          <button
            onClick={onCancel}
            className="bg-blue-500 text-white px-4 py-2 ml-2 rounded-md"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog ;

